import * as React from 'react';
const classNames = require('classnames');

interface IButtonProps {
	type?: 'submit' | 'reset' | 'button';
	disabled?: boolean;
	size?: 'extrasmall' | 'small' | 'medium' | 'large';
	usage?: 'portal' | 'admin';
	children: any;
	onClick?: (e: any) => void;
	onClickCapture?: (e: any) => void;

	className?: string;
}

interface IBaseButtonProps extends IButtonProps {
	style?:
		| 'primary'
		| 'white'
		| 'red'
		| 'black'
		| 'EllipseGreenBlack'
		| 'EllipseGreenWhite'
		| 'EllipseGreyBlack'
		| 'EllipseGreyWhite'
		| 'EllipseBlackWhite'
		| 'BasicButton'
		| 'BasicButtonGrey'
		| 'bottom'
		| 'round'
		| 'underline';
}

const BUTTON_SIZES = {
	extrasmall: 'bsPortalBtnExtraSmall',
	small: 'bsPortalBtnSmall',
	medium: 'bsPortalBtnMedium',
	large: 'bsPortalBtnLarge',
};

const BUTTON_USAGE = {
	portal: 'bsPortalBtn',
	admin: 'btnAdmin',
};

const BaseButton = (props: IBaseButtonProps) => {
	const size = props.size ? BUTTON_SIZES[props.size] : BUTTON_SIZES.large;
	const usage = props.usage ? BUTTON_USAGE[props.usage] : BUTTON_USAGE.portal;

	const button = (
		<button
			type={props.type || 'button'}
			disabled={props.disabled}
			onClick={props.onClick}
			onClickCapture={props.onClickCapture}
			className={classNames(
				props.className,
				{ ['btnPrimary']: props.style === 'primary' },
				{ ['btnWhite']: props.style === 'white' },
				{ ['btnRed']: props.style === 'red' },
				{ ['btnBlack']: props.style === 'black' },
				{ ['btnEllipseGreenBlack']: props.style === 'EllipseGreenBlack' },
				{ ['btnEllipseGreenWhite']: props.style === 'EllipseGreenWhite' },
				{ ['btnEllipseGreyBlack']: props.style === 'EllipseGreyBlack' },
				{ ['btnEllipseGreyWhite']: props.style === 'EllipseGreyWhite' },
				{ ['btnEllipseBlackWhite']: props.style === 'EllipseBlackWhite' },
				{ ['btnBasic']: props.style === 'BasicButton' },
				{ ['btnBasicGrey']: props.style === 'BasicButtonGrey' },
				{ ['btnBottom']: props.style === 'bottom' },
				{ ['btnRound']: props.style === 'round' },
				{ ['btnUnderline']: props.style === 'underline' },
				usage,
				size,
			)}
		>
			{props.children}
		</button>
	);

	return button;
};

export const Button = (props: IButtonProps) => <BaseButton {...props} style="primary" />;

export const BottomButton = (props: IButtonProps) => <BaseButton {...props} style="bottom" />;

export const WhiteButton = (props: IButtonProps) => <BaseButton {...props} style="white" />;

export const RedButton = (props: IButtonProps) => <BaseButton {...props} style="red" />;

export const BlackButton = (props: IButtonProps) => <BaseButton {...props} style="black" />;

export const EllipseGreenBlackButton = (props: IButtonProps) => <BaseButton {...props} style="EllipseGreenBlack" />;

export const EllipseGreenWhiteButton = (props: IButtonProps) => <BaseButton {...props} style="EllipseGreenWhite" />;

export const EllipseGreyBlackButton = (props: IButtonProps) => <BaseButton {...props} style="EllipseGreyBlack" />;

export const EllipseGreyWhiteButton = (props: IButtonProps) => <BaseButton {...props} style="EllipseGreyWhite" />;

export const EllipseBlackWhiteButton = (props: IButtonProps) => <BaseButton {...props} style="EllipseBlackWhite" />;

export const BasicButton = (props: IButtonProps) => <BaseButton {...props} style="BasicButton" />;

export const BasicButtonGrey = (props: IButtonProps) => <BaseButton {...props} style="BasicButtonGrey" />;

export const ButtonRound = (props: IButtonProps) => <BaseButton {...props} style="round" />;

export const UnderlineButtonGrey = (props: IButtonProps) => <BaseButton {...props} style="underline" />;
